import Section from "@/components/ui/section";
import React, { useEffect, useState } from "react";
import Slick from "@/components/ui/carousel/slick";
import CaseStudy from "./case-study";
import { useRouter } from "next/router";
import CaseStudyLink from "./case-study-link";
export default function CaseStories() {
  const [open, setOpen] = useState(false);
  const router = useRouter();
  useEffect(() => {
    setOpen(false);
  }, []);
  function onSlideChange(value) {
    setOpen(false);
  }
  return (
    <Section className="!bg-[#F4F9FF]">
      <Slick
        slidesToShow={1}
        slidesToScroll={1}
        navigation={true}
        dots={false}
        autoplay={false}
        onSlideChange={onSlideChange}
      >
        {router?.pathname === "/migrants-resilience-collaborative" && (
          <CaseStudyOne open={open} />
        )}
        {router?.pathname === "/migrants-resilience-collaborative" && (
          <CaseStudyTwo open={open} />
        )}
        {router?.pathname === "/migrants-resilience-collaborative" && (
          <CaseStudyThree open={open} />
        )}
        {router?.pathname === "/migrants-resilience-collaborative" && (
          <CaseStudyFour open={open} />
        )}
        {router?.pathname === "/grassroots-leadership-and-capacity" && (
          <CaseStudyFive open={open} />
        )}
        {router?.pathname === "/grassroots-leadership-and-capacity" && (
          <CaseStudySix open={open} />
        )}
        {router?.pathname === "/global-climate-resilience-collective" && (
          <CaseStudySeven open={open} />
        )}
        {router?.pathname === "/global-climate-resilience-collective" && (
          <CaseStudyEight open={open} />
        )}
        {router?.pathname === "/global-climate-resilience-collective" && (
          <CaseStudyNine open={open} />
        )}
        {router?.pathname === "/global-climate-resilience-collective" && (
          <CaseStudyTen open={open} />
        )}
      </Slick>
    </Section>
  );
}
const CaseStudyOne = ({ open }) => {
  return (
    <CaseStudy
      title="A case study on MRC’s systems change work with the government of Chhattisgarh"
      image="/images/mrc/1 MRC CASE STORY 1 1200 x 400.webp"
      openState={open}
    >
      <p>
        Chhattisgarh is a state in central India with a migrant population
        estimated at around 4.5M (15% of the state population of ~30M). MRC
        started last-mile social protection delivery for migrants in
        Chhattisgarh in September 2020 (and now has centers in 5 districts
        reaching nearly 200,000 migrant households). In October 2020, MRC began
        its first government partnership work with the Government of
        Chhattisgarh’s Labour Department.
      </p>
      <p>
        MRC staff provided recommendations based on field insights and desk
        research, for changes that can create more migrant-inclusive
        infrastructure, and engage with the top bureaucrats to prioritize among
        these. The specific areas where the MRC team provided recommendations
        were:
      </p>
      <ul>
        <li>Redesign of Labour Card Registration Forms</li>
        <li>Development of a Mobile Application</li>
        <li>
          Designing government-funded volunteer program for delivery of
          last-mile services
        </li>
        <li>Redesign of back-end applications processing</li>
      </ul>
      <p>
        MRC’s efforts particularly on strengthening backend processes served as
        the biggest contributor in reducing wait times for application
        processing: the proportion of applications pending over 30-days fell
        from 42-52% (between 2019 and 2021) to 35% (in 2022).
      </p>
    </CaseStudy>
  );
};
const CaseStudyTwo = ({ open }) => {
  return (
    <CaseStudy
      title="Education Scholarship for the child of a construction worker"
      image="/images/mrc/MRC CASE STORY 2 1200 x 400.webp"
      openState={open}
    >
      <p>
        Narendra Chinchkhede, a migrant construction worker from the remote
        Bhandara district in Maharashtra, India, exemplifies the resilience and
        determination of countless individuals striving to improve their lives.
        Despite facing numerous challenges, including economic hardship, limited
        access to education, and physical and psychological vulnerabilities,
        Narendra remained steadfast in his commitment to providing his daughters
        with a quality education.
      </p>
      <p>
        Before migrating to Pune, Narendra and his family lived in a rural area
        of Bhandara district, one of the most backward regions in Maharashtra.
        The family struggled to make ends meet, relying on daily wages from
        farming and other manual labor. Narendra&apos;s decision to leave his
        family behind and seek work in Pune was driven by his desire to secure a
        better future for them. In Pune, Narendra found employment as an
        electrician at a construction site. His income, however, was limited,
        and he faced financial constraints in meeting his family&apos;s needs,
        including education expenses. Despite these challenges, Narendra
        remained dedicated to his daughters&apos; education.
      </p>
      <p>
        Through his association with Jansahas Foundation, Narendra became aware
        of the Building and Other Construction Workers&apos; (BOCW) Welfare
        Board and its benefits. With our support, Narendra successfully
        registered with the BOCW and applied for a scholarship for his daughter,
        Sneha&apos;s, higher education. After facing delays, Narendra&apos;s
        persistence and our efforts eventually led to the disbursement of the
        BOCW scholarship worth Rs. 60,000. This significant financial boost has
        alleviated Narendra&apos;s financial burden and enabled him to support
        Sneha&apos;s educational pursuits.
      </p>
      <p>
        The receipt of the scholarship is a testament to Narendra&apos;s
        perseverance and the effectiveness of social protection programs in
        empowering vulnerable individuals. It highlights the importance of
        providing support and resources to migrant workers, enabling them to
        overcome challenges and achieve their goals.
      </p>
    </CaseStudy>
  );
};
const CaseStudyThree = ({ open }) => {
  return (
    <CaseStudy
      title="A case study on MRC’s support to a family access social protection and an alternate source of income"
      image="/images/home/home_banner_01.webp"
      openState={open}
    >
      <p>
        In the remote village of Chorhat, located in Palamu, Jharkhand, lives
        Shivmani Devi. Despite facing the challenges of disability, Shivmani has
        managed her household alongside her husband. Their life, however, has
        been marked by struggles due to limited financial resources. The couple
        is mostly left to fend for themselves as their elder son, a migrant
        worker, toils away in the building construction sector in Chennai. Like
        many other migrant families, he is compelled to seek better
        opportunities far from home, leaving his parents behind.
      </p>
      <p>
        During a routine field visit in Chorhat village, MRC field staff came
        across Shivmani Devi’s family. He observed the difficult circumstances
        they were enduring—financial hardships compounded by isolation, with
        their primary source of sustenance being subsidised foodgrains offered
        under the government Public Distribution System.
      </p>
      <p>
        Recognizing her situation, Shivmani Devi expressed a desire for an
        alternative source of income that could help her sustain a better
        quality of life. She longed for financial independence and stability
        despite her physical limitations. Understanding the urgency of her
        situation, the MRC staff identified that she was eligible for the
        Pashudhan Yojana, a government scheme that offers livestock at
        subsidized rates to beneficiaries, aimed at promoting self-sustaining
        rural livelihoods.
      </p>
      <p>
        In February 2024, with the guidance and support of the MRC team,
        Shivmani Devi completed the necessary paperwork and submitted her
        application for the scheme at the Ramgarh block office. Praveen Ji’s
        assistance was critical not only in navigating the application process
        but also in providing Shivmani Devi with complete information on how the
        scheme could benefit her.
      </p>
      <p>
        On May 4th, 2024, the efforts paid off. Shivmani Devi received a cow
        under the Pashudhan Yojana at a subsidised rate. This new addition to
        her household brought hope and a renewed sense of purpose. She began
        selling milk in the village at ₹50 per litre, which quickly became a
        reliable source of income, improving their quality of life
        significantly.
      </p>
      <p>
        But the support did not end there. Recognizing that Shivmani Devi is
        disabled, the MRC team also helped submit an application for a
        disability pension, ensuring she could access the benefits she is
        entitled to.{" "}
      </p>
    </CaseStudy>
  );
};
const CaseStudyFour = ({ open }) => {
  return (
    <CaseStudy
      title="A case study on MRC’s timely intervention on the field"
      image="/images/home/home_banner_01.webp"
      openState={open}
    >
      <p>
        Bheerappa is a 32-year-old migrant worker from a village in the Bellary
        district of Karnataka. In Bellary, Bheerappa earned ₹200 (~$2.5) a day
        working as an agricultural labourer, while his wife earned ₹100-150 for
        the same work. With three young children and expenses mounting, he
        started migrating to the state capital – Bangalore – 180 miles from
        home, to work on construction sites with his wife and brother.
      </p>

      <p>
        About two years ago Bheerappa started complaining of back pain. Over the
        next year, he tried multiple treatments and went to multiple doctors,
        but the pain only grew intolerable. To make matters worse, he had no
        savings, no insurance, and had to borrow money from local money lenders
        at 2-3% interest per month. His debt rose to over ₹4,00,000 (~$5,000)
        before he finally went to a hospital in Bangalore and received the right
        diagnosis: early-stage cancer. The money lenders sympathised and agreed
        to give him more time to repay his debts, but Bheerappa could not see
        how things were going to get better.
      </p>

      <p>
        Bheerappa met MRC’s field team member – Venkatesh – for the first time
        during the lockdown, when Venkatesh brought family emergency food
        rations as part of MRC’s relief operations. Hearing about his health
        issues, the team helped his family enroll in the Government of India’’s
        health insurance program, Ayushman Bharat. This came at a critical time
        for two reasons. First, Bheerappa was unable to afford the chemotherapy
        sessions at the hospital. Second, he had to stop working due to his pain
        and his family was beginning to struggle for food as they were entirely
        dependent on his wife’s ₹400-500 rupees a day income working odd jobs as
        a construction helper or domestic worker.
      </p>
    </CaseStudy>
  );
};
const CaseStudyFive = ({ open }) => {
  return (
    <CaseStudy
      title="Kranti"
      image="/images/gri/gri-case story 1.webp"
      openState={open}
    >
      <p>
        Kranti is a Pune-based nonprofit founded in 2010 by Sunita Bhosale to
        address issues faced by the Pardhi tribe, a marginalized Nomadic
        community. Initially, Kranti needed resources and knowledge about
        managing an organization. Sunita, who belongs to the Pardhi tribe, knew
        little about accounting, fundraising, or organizational development,
        which made it challenging to expand their work.
      </p>
      <p>
        Despite these challenges, Kranti continued to work in 10 villages,
        focusing on issues like violence, land rights, education, and health.
        However, by 2019, they realized that to grow and have a greater impact,
        they needed more staff and better organizational structures.
      </p>
      <p>
        In due course of time, Kranti connected with the Grassroots Resilience
        Institute (GRI) to seek support for Organizational Development. Through
        GRI, Kranti received support in critical areas of OD such as staff
        capacity building, financial management, and establishing formal
        policies and systems. Kranti’s staff also received training in
        documentation, fundraising, and financial management. This enabled them
        to write better proposals, manage their finances more effectively, and
        connect with other nonprofits and funders.
      </p>
      <p>
        Kranti also established policies, including those on finance, equal
        opportunity, and code of conduct, which helped streamline their
        operations and bring transparency to their work. They hired an
        accountant, improved financial controls, and started using accounting
        software, which enhanced their ability to plan and execute programs in a
        better way. Although, there were positive changes, implementing new
        policies was challenging for the staff, who had to adapt to new
        processes and documentation requirements. To address this, Kranti
        conducted training sessions to help the staff understand the importance
        of these policies.
      </p>
      <p>
        Looking ahead, Kranti plans to expand its work to 100–150 villages,
        aiming to make these communities self-reliant. Their goal is to end the
        historical exclusion and stigmatization of de-notified tribes and uplift
        marginalized groups.
      </p>
    </CaseStudy>
  );
};
const CaseStudySix = ({ open }) => {
  return (
    <CaseStudy
      title="Sukhaya"
      image="/images/gri/gri-case story 2.webp"
      openState={open}
    >
      <h6>Background and Growth Potential </h6>
      <p>
        Sukhaya, a young organization registered on April 15, 2022, under the
        Companies Act 2013, focuses on capacity building, awareness, and
        informal education. Its mission is to empower teachers and students by
        providing essential knowledge on personal safety, gender rights, and
        sexual and reproductive health. Sukhaya also promotes gender equality
        and equity through community-focused initiatives.{" "}
      </p>
      <p>
        Initially reliant on volunteers for community awareness sessions,
        Sukhaya transitioned to hiring staff to ensure sustainability and
        impact. This shift was driven by the founder&apos;s dedication and
        experience, helping establish robust financial and governance systems.
      </p>
      <h6>Partnership with GRI</h6>
      <p>
        In August 2023, after a thorough selection process, Sukhaya partnered
        with GRI (Grassroots Resource Initiative). GRI&apos;s support marked a
        significant turning point, allowing Sukhaya to refine operational
        strategies and enhance its capacity for sustainable growth.
      </p>
      <h6>Support and Organizational Development</h6>
      <p className="font-bold">GRI&apos;s support focused on key areas:</p>
      <p>
        <strong>Fundraising:</strong> Assisted in drafting three proposals,
        laying a strong foundation for future resource mobilization.
      </p>
      <p>
        <strong>Financial Systems:</strong> Transitioned from manual accounting
        to Tally, improving financial management.
      </p>
      <p>
        <strong>Governance:</strong> Expanded the governing board with diverse
        members to strengthen decision-making.
      </p>
      <p>
        <strong>Hiring Processes:</strong> Developed structured recruitment
        procedures, aligning hires with organizational values.
      </p>
      <p>
        <strong>Funding Allocation:</strong> Hired a part-time accountant and a
        fundraising officer, crucial for financial and resource management.
      </p>
      <p>
        <strong>Organizational Policies:</strong> Supported drafting of
        organization policies such as finance, HR, POSH, safeguarding, and child
        protection.
      </p>
      <h6>Impact of GRI&apos;s Support </h6>
      <p>
        Sukhaya has made significant progress since GRI&apos;s involvement,
        expanding operations, recruiting a dedicated team, and implementing
        critical policy changes. The founder has benefited from
        capacity-building efforts, enhancing their understanding of
        organizational development.
      </p>
      <h6>Sukhaya Future Plan </h6>
      <p>
        Sukhaya aims to expand its programs to marginalized communities,
        strengthen organizational capacity, diversify funding sources, and build
        strategic partnerships. Prioritizing monitoring and evaluation, the
        organization will focus on leadership development and effective program
        outcomes. With continued support from funders and partners, Sukhaya is
        positioned to amplify its impact and promote gender equality.
      </p>
    </CaseStudy>
  );
};
const CaseStudySeven = ({ open }) => {
  return (
    <CaseStudy
      title="Feeling the heat: The volatility of brick-making <br/><i>(Ateeq Khan | Brick Kiln Worker, India)</i>"
      image="/images/cli/ateeq khan case story pic.webp"
      openState={open}
    >
      <p>
        The intense heat of brick kilns is familiar to Ateeq Khan, a resident of
        Narayach village in the northern Indian state of Uttar Pradesh. Ateeq
        has worked as a labourer in brick kilns since the age of fifteen. He is
        the primary breadwinner for his family, which includes his elderly
        parents, wife, and five children. His work at the kiln involves placing
        raw bricks into the furnace and removing them once ready. For this
        labour-intensive task, he earns 300 rupees (less than $4) a day.
      </p>

      <p>
        Extreme heat combined with continuous exposure to dust and pollution has
        made the task of handling bricks challenging, often hampering Ateeq’s
        ability to work. He frequently suffers from health issues due to the
        heat.
      </p>
      <p>
        The nature of work in the brick kilns has also led to severe injuries,
        leaving him unable to work for days at a time. His meagre income forces
        him to put off medical care in such scenarios, as he prioritizes the
        care of his elderly parents and other family members. He worries about
        their well-being if he is unable to work.{" "}
        <strong>
          “If I do not work, my family would be on the streets,” he says.
        </strong>
      </p>
      <p>
        The number of employment days in the brick kilns is inconsistent. During
        rains, work halts as brick production (drying and firing bricks) is
        heavily reliant on dry weather. Changing weather patterns have further
        increased this inconsistency. Ateeq mentions,{" "}
        <strong>
          “Earlier, we knew when it would rain, but these days the season is
          very unpredictable,”
        </strong>{" "}
        further affecting his workdays and wages.
      </p>
      <p>
        Ateeq’s migration from his village near a river was also driven by
        weather events. During the monsoon season, floods frequently complicated
        his ability to secure consistent work. Volatile weather patterns pushed
        him to find alternate sources of employment.
      </p>
      <p>
        For almost six months a year, he migrates to neighbouring states like
        Chhattisgarh, where he works on construction sites and in brick kilns.
        Forced into a cycle of debt and migration, Ateeq has taken a loan of
        40,000 rupees ($477) from a microfinance group in his village to cope
        with household damages during floods, which he is gradually repaying.
        Despite working tirelessly, he admits he is unable to consistently meet
        his family’s basic needs due to low wages.{" "}
        <strong>
          “Usually, what we get is subsistence money for food on a weekly basis
          for daily expenses,”
        </strong>{" "}
        he explains. When working in other states, he hesitates to insist on
        timely payments, fearing job loss.
      </p>
      <p>
        Ateeq’s children attend the local government school, but he is unsure of
        his ability to provide them with a better future.{" "}
        <strong>
          “Humari koi aukat nahi hai ki hum unko koi naukari dila sake (I do not
          have the capacity to be able to get my children a job),”
        </strong>{" "}
        he says. His current focus is on his oldest daughter’s wedding.{" "}
        <strong>“I work overtime to get my daughter married,”</strong>
        he notes.
      </p>
      <p>
        There has been some respite for Ateeq in the past year. Through the
        support of a local non-profit organization working with the Migrants
        Resilience Collaborative (MRC), he received crucial assistance in the
        form of access to a BOCW card.
      </p>
      <p>
        The harsh realities faced by labourers in rural India are exacerbated by
        changing weather patterns and systemic challenges. Even as support from
        non-profit organizations provides some relief for internal migrants such
        as Ateeq, there is a pressing need for broader systemic solutions to
        ensure sustainable livelihoods for workers during this growing climate
        crisis.
      </p>
    </CaseStudy>
  );
};

const CaseStudyEight = ({ open }) => {
  return (
    <CaseStudy
      title="Vanishing catch: The dilemma of a fishing community<br/> <i>(Santa Kumar | Fisherman, Nepal)</i>"
      image="/images/cli/Santa picture  case story.webp"
      openState={open}
    >
      <p>
        <strong>
          “The river used to give us life, but now it feels like it’s slipping
          away,”
        </strong>{" "}
        says 34-year-old Santa Kumar Majhi from the rural municipality of
        Champadevi in Nepal. The calloused hands of this father of six are a
        testament to a life of labor. He belongs to the Majhi community, an
        indigenous group associated with fishing and boating along the
        riverbanks of the inner Terai region. Santa Kumar, who was taught how to
        fish by his father, says,{" "}
        <strong>
          “Fishing has been part of my family’s legacy for generations, but it’s
          no longer enough.”
        </strong>
      </p>
      <p>
        The community’s way of life has been severely disrupted by development
        projects, environmental degradation, and overfishing. There was a time
        when the fishing community used to catch enough to feed their families.
        However, over the last several years, water levels in the once-abundant
        rivers of Sunkoshi and Likhu have dropped.{" "}
        <strong>
          “There are about 80 Majhi households here, and most of us depend on
          the rivers. The water is reducing, the fish are disappearing, and with
          them, our ability to survive,”
        </strong>{" "}
        Santa Kumar notes.
      </p>
      <p>
        The Majhi community has also relied on small-scale agriculture to make
        ends meet. However, irregular weather patterns, including prolonged
        droughts and unseasonal rains, have ravaged farmlands. Most in the
        community are landless labourers, owning only tiny parcels of land.
        Droughts have reduced grazing pastures, impacting both livestock and
        crop yields.{" "}
        <strong>
          “I work on my small farm, but it’s not enough. The crops fail often,
          and we barely make it through the year. It’s ruining our harvests,”
        </strong>{" "}
        Santa Kumar explains. In recent years, many from the community have had
        to leave their farmlands fallow.
      </p>
      <p>
        Intersecting with these environmental challenges are social and economic
        issues, such as limited access to education, healthcare, and stable
        employment for vulnerable communities like the Majhis. Many in the
        community, including Santa Kumar, lack education and formal training.
        <strong>“There are few opportunities for us,”</strong> he admits.{" "}
        <strong>
          “Most young people are forced to leave home for work, but even then,
          it’s hard to find good jobs.”
        </strong>
      </p>
      <p>
        The Majhis largely live under the poverty line, facing social exclusion
        and caste-based discrimination. Santa Kumar admits that his family
        struggles to make ends meet for several months of the year. With six
        children to care for, his eldest daughter has already started working in
        Kathmandu as a domestic worker, while his son has taken on daily wage
        labor in the village.{" "}
        <strong>
          “I wanted my children to get an education, to have a better life than
          me,”
        </strong>{" "}
        he says, his voice heavy with regret.{" "}
        <strong>
          “But we had no choice. They had to work to help us survive.”
        </strong>
      </p>
      <p>
        Santa Kumar emphasizes the need for systemic support. He believes that
        vocational training and a push for small-scale businesses would help his
        community diversify their incomes instead of solely depending on fishing
        and agriculture.{" "}
        <strong>
          “Without support, our children will continue to leave for cities, and
          our village will slowly disappear,”
        </strong>{" "}
        he says.
      </p>
      <p>
        Despite the hardships life keeps throwing his way, Santa Kumar’s
        determination for his family’s survival remains strong.{" "}
        <strong>“I have some hope left,”</strong> he says, his eyes fixed on the
        horizon.{" "}
        <strong>
          “If we get help, maybe my children will not have to struggle like I
          did. Maybe they can go back to school. But without help, we will keep
          losing everything – the land, the rivers, our future.”
        </strong>
      </p>
    </CaseStudy>
  );
};

const CaseStudyNine = ({ open }) => {
  return (
    <CaseStudy
      title="Between floods and heatwaves: A story of resilience in a changing climate <br/><i>( Jovelyn Cottelion | Street vendor, Philippines)</i>"
      image="/images/cli/Jovelyn case storuy picture.webp"
      openState={open}
    >
      <p>
        <strong>
          “During the rainy season, it is difficult to sell items. We end up
          losing income for the day,”
        </strong>{" "}
        says Jovelyn Cottelion, a 45-year-old mother of four. Jovelyn originally
        belongs to Payatas, Quezon City in the Philippines.
      </p>
      <p>
        After migrating for multiple years in search of better opportunities,
        Jovelyn, with her family, returned to Payatas in the past year.{" "}
        <strong>
          “When my husband’s work contract ended, and we didn’t have any income.
          We had to move back to Payatas because we couldn’t afford the rent,”
        </strong>{" "}
        she informs.
      </p>
      <p>
        Her husband, Eric, is the main breadwinner but to supplement the
        family’s income, Jovelyn works as a street vendor, selling eggs. Like
        many in her community, she has seen the once predictable climate become
        increasingly erratic, bringing new challenges to her already difficult
        life. She lives in a coastal area that has been severely impacted by
        climate change. Typhoons, once seasonal, now strike with unexpected
        frequency and intensity. Each storm brings with it floods, leaving the
        community vulnerable.
      </p>
      <p>
        Jovelyn’s struggle is made worse by extreme weather events that
        regularly hit her coastal areas.{" "}
        <strong>
          “When it rains heavily, it floods our house, and we cannot even sell
          anything from the store.”
        </strong>{" "}
        The flooding of the streets and homes makes it impossible for Jovelyn to
        sell, losing a day’s income. She informs,{" "}
        <strong>
          “If it floods during rains, only a few people come out to buy and the
          sale is much less. I am unable to even get raw products from the
          market.”
        </strong>
      </p>
      <p>
        Her family’s income is also affected by the rising temperatures.{" "}
        <strong>
          “When it gets too hot, I can’t let the children go outside. My husband
          has high blood pressure, and the heat makes it worse,”
        </strong>{" "}
        Jovelyn explains. The scorching heat not only affects the health of her
        family, but also limits her ability to run the store.{" "}
        <strong>
          “On really hot days as well, fewer people come outside to buy.”
        </strong>{" "}
        This means the little income she makes from her store reduces further
        with different weather events. Her husband, a construction worker, is
        also affected by the heat.{" "}
        <strong>
          “He doesn’t get called for work as often because it’s too hot for work
          to continue.”
        </strong>
      </p>
      <p>
        The challenges Jovelyn faces are further compounded by the rising cost
        of goods due to weather disruptions.{" "}
        <strong>“The price of everything is going up,”</strong> she says.{" "}
        <strong>
          “I used to buy and sell 50 trays of eggs, but now I can only afford to
          buy 10 trays.”
        </strong>{" "}
        The combination of extreme weather and increasing prices has left
        Jovelyn with fewer products to sell, which cuts deeply into her profits.{" "}
        <strong>
          “We’re barely making enough to cover our expenses for water,
          electricity, and food.”
        </strong>
      </p>
      <p>
        Jovelyn’s situation reflects a broader crisis in the Philippines, as the
        country is one of the most disaster-prone, facing an average of twenty
        typhoons and torrential rains each year.
      </p>
      <p>
        The constant struggle to make ends meet has pushed Jovelyn and her
        family into debt.{" "}
        <strong>
          “If we don’t make enough, we owe money to Bombay (private money
          lenders),”
        </strong>{" "}
        she says, referring to local private creditors. With her husband only
        earning minimum wage and construction work being unreliable, their
        financial situation remains fragile. Despite her struggles, Jovelyn
        continues to hope for a better future for her children. She informs,{" "}
        <strong>
          “If we could receive extra support for the education expenses of our
          children, it would really support our family. Especially my young
          children, who are still in elementary school. The income from
          construction is minimal.”
        </strong>
      </p>
      <p>
        With limited coping mechanisms and support from governments for families
        such as Jovelyn’s, the cycle of poverty persists, made worse by the
        changing and harsh climate conditions.
      </p>
      <p>
        The impacts of climate change are not just environmental; they
        exacerbate pre-existing social and economic challenges. Many like
        Jovelyn work in precarious jobs that provide little in terms of security
        or benefits. Urgent action is needed to ensure a more secure future for
        vulnerable individuals such as Jovelyn and her family.
      </p>
    </CaseStudy>
  );
};
const CaseStudyTen = ({ open }) => {
  return (
    <CaseStudyLink
      link="/pdfs/PCI_Case Study Booklet_Revised Digital_ Final_20092024 (1).pdf"
      title="To know more, see:"
      subTitle="Voices of Resilience: Stories of internal migrants coping with climate change <i>(18 written and video stories from South and Southeast Asia)</i>"
      image="/images/cli/CRI frame 4 picture.webp"
    />
  );
};
